import axios from '../axios';
const END_POINT = '/permission-units';


const addPermissionUnits = (payload) => axios.post(`${END_POINT}`, payload);
const getPermissionUnits = (payload) => axios.get(`${END_POINT}?limit=${payload.limit}&page=${payload.page}`);
const getPermissionUnit = (permissionUnitsId) => axios.get(`${END_POINT}/${permissionUnitsId}`);
const updatePermissionUnits = (id, payload) => axios.patch(`${END_POINT}/${id}`, payload);
const searchPermissionUnits = (payload) => axios.post(`${END_POINT}/search`, payload);
const deletePermissionUnits = (permissionUnitsId) => axios.delete(`${END_POINT}/${permissionUnitsId}`);

export {
    addPermissionUnits,
    getPermissionUnits,
    getPermissionUnit,
    updatePermissionUnits,
    searchPermissionUnits,
    deletePermissionUnits
}
